import { IGetRolesByFunctionResponse } from "modules/cargos/models/dtos/IGetRolesByFunctionResponse";
import { ICargosApiService } from "modules/cargos/models/interface/ICargosApiService";

export const getRolesByFunctionUseCase = async ( service: ICargosApiService, ownerId: string ): Promise<IGetRolesByFunctionResponse[]> => {
  const response = service.getRolesByFunction(ownerId);
  return response;
};
